import { render } from "./TopicsHeader.vue?vue&type=template&id=7584a89b"
import script from "./TopicsHeader.vue?vue&type=script&lang=js"
export * from "./TopicsHeader.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/prod/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__